import { NgModule } from '@angular/core';
import { HomeRoutingModule } from './home-routing.module'
import { HomeComponent } from './home.component';
import { TableModule } from 'primeng/table';
import { HttpClientModule, HTTP_INTERCEPTORS, } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { EditDealerComponent } from './edit-dealer.component';
import { CommonModule } from '@angular/common';
import { TrackingLogComponent } from './tracking-log.component';
import {PanelModule} from 'primeng/panel';
import { FormsModule } from '@angular/forms';
import {DialogModule} from 'primeng/dialog';
import { NgxPermissionsModule } from 'ngx-permissions';
import {TabMenuModule} from 'primeng/tabmenu';
import { ManageReturnMailerComponent } from './manage-returnmailer.component';
import {InputMaskModule} from 'primeng/inputmask';
import { MultiSelectModule} from 'primeng/multiselect';
import {DropdownModule} from 'primeng/dropdown';
import {TabViewModule} from 'primeng/tabview';
import {RadioButtonModule} from 'primeng/radiobutton';
import { CdkDealerMappingComponent } from './cdk-dealer-mapping.component';
import { SubscribersListComponent } from './subscribers-list.component'
import { ClientSubscriptionDealersComponent } from './client-subscription-dealers.component'
import { EditSubscriberComponent } from './edit-subscriber.component';
import {SelectButtonModule} from 'primeng/selectbutton';


@NgModule({
  imports: [
    HomeRoutingModule,
    TableModule,
    TabViewModule,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    PanelModule,
    FormsModule,
    DialogModule,
    NgxPermissionsModule,
    TabMenuModule,
    InputMaskModule,
    MultiSelectModule,
    DropdownModule,
    RadioButtonModule,
    SelectButtonModule
  ],
  declarations: [    
    HomeComponent,
    EditDealerComponent,
    TrackingLogComponent,
    ManageReturnMailerComponent,
    CdkDealerMappingComponent,
    SubscribersListComponent,
    EditSubscriberComponent,
    ClientSubscriptionDealersComponent
  ]
})
export class HomeModule { }
